import { defaultDataImage } from "./state";

/**
 * Mutación para restablecer los datos de la imagen.
 *
 * @param {*} state
 * @author Fernando Claros
 */
export function resetSecondaryImage(state) {
  state.secondaryImage = defaultDataImage()
}

/**
 * Mutación manipular/alterar los datos de la imagen.
 *
 * @param {*} state
 * @param {*} nextState
 * @author Fernando Claros
 */
export function setSecondaryImage(state, nextState) {
  state.secondaryImage = nextState
}

/**
 * Mutación manipular/alterar los para la imagen que se previsualiza.
 *
 * @param {*} state
 * @param {*} nextState
 * @author Fernando Claros
 */
export function setImgPreviewPath(state, nextState) {
  state.imgPreviewPath = nextState
}

/**
 * Mutación para restablecer los datos de la imagen previsualiza.
 *
 * @param {*} state
 * @author Fernando Claros
 */
export function resetImgPreviewPath(state) {
  state.imgPreviewPath = null
}